import { createSlice, createAsyncThunk } from '@reduxjs/toolkit';

const initialState = {
  accessoriesThingsData: [],
  accessoriesLoader: true,
  accessoriesError: "",
};

// const getEndpoint = (roomName, location) => {
//   const loc = location?.toUpperCase().trim();
//   const prefix = loc === 'KKT' ? 'kkt' : '';
//   return `https://us-central1-fabdiz-quote.cloudfunctions.net/api/rooms/${prefix}${roomName}`;
// };

const getEndpoint = (roomName) => {
   const loc = localStorage.getItem('userLocation');
   const prefix = loc === 'kkt' ? 'kkt' : '';
  // const prefix = localStorage.getItem('userLocation');
  const db = localStorage.getItem('projectDatabase') || '(default)'; // fallback for safety
  // return `https://us-central1-fabdiz-quote.cloudfunctions.net/api/rooms/${prefix}${roomName}`;
  return `https://us-central1-fabdiz-quote.cloudfunctions.net/api/rooms/${prefix}${roomName}/${db}`;
};



export const fetchAccessoriesList = createAsyncThunk(
  'fetchAccessories',
  async ({  } = {}, { rejectWithValue }) => {
    try {
      const url = getEndpoint('Accessories');
      const response = await fetch(url);
      if (!response.ok) throw new Error('Failed to fetch accessories data');
      return await response.json();
    } catch (error) {
      return rejectWithValue(error.message);
    }
  }
);

const accessoriesReducer = createSlice({
  name: 'accessories',
  initialState,
  reducers: {},
  extraReducers: {
    [fetchAccessoriesList.fulfilled]: (state, action) => {
      state.accessoriesThingsData = action.payload;
      state.accessoriesLoader = false;
      state.accessoriesError = "";
    },
    [fetchAccessoriesList.pending]: (state) => {
      state.accessoriesLoader = true;
      state.accessoriesError = "";
    },
    [fetchAccessoriesList.rejected]: (state, action) => {
      state.accessoriesLoader = false;
      state.accessoriesError = action.payload ?? "refresh the page";
    },
  },
});

export default accessoriesReducer.reducer;